.searchField {
  width: 240px;
}
